export const getFetchCnt = state => state.translations.fetchCnt;
export const getTranslations = state => state.translations.translations;
export const getLocale = state => state.translations.locale;
export const getLocaleUserSelected = state =>
  Boolean(state.translations.localeUserSelected);
export const getMarketTranslations = state =>
  state.translations.marketTranslations;
